export default {
  form: {
    country: {
      label: 'Country',
      placeholder: 'Select country',
    },
  },
};
